import React, { useState } from 'react';

import Heading from '@atlaskit/heading';
import moment from 'moment';

const LEVEL_LEN = 7;

const LogMessage = ({ timestamp, level, message }) => {
  level = level || '';
  while (level.length < LEVEL_LEN) level = ` ${level}`;
  if (level.length > LEVEL_LEN) level = level.substring(0, LEVEL_LEN);

  const time = moment(timestamp).format('HH:mm:ss.SSS');

  return (
    <span className={`log-record log-record-level-${level.trim()}`}>
      <span className="time">{time}</span>
      <span className="level">[{level}]</span>
      <span className="message">{message}</span>
    </span>
  );
};

const ViewLogs = ({ logs }) => {
  const [hideDebugMessages, setHideDebugMessages] = useState(true);
  const requestId = (logs[0] && logs[0].request_id) || 'no-request';

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
        <Heading size="small">Messages:</Heading>
        <div>
          <label style={{ marginRight: '20px' }}>
            <input type="checkbox" checked={hideDebugMessages} onChange={() => { setHideDebugMessages(h => !h); }}/>Hide debug messages
          </label>
          <span style={{ fontWeight: 'bold', fontStyle: 'italic', marginRight: '20px' }}>requestId: {requestId}</span>
        </div>
      </div>
      <div className="logs-container">
        {logs
          .filter(l => !(hideDebugMessages && l && l.level && l.level === 'debug'))
          .map((l, i) => <LogMessage key={`${requestId}-${i}`} {...l}/>)}
      </div>
    </div>
  );
};

export default ViewLogs;
